import { Component, ElementRef, ViewChild } from '@angular/core';
declare let tableau: any;

@Component({
  selector: 'app-interviews',
  templateUrl: './interviews.component.html',
  styleUrls: ['./interviews.component.scss'],
})
export class InterviewsComponent {
  viz: any;
  @ViewChild('vizContainer') containerDiv: ElementRef;

  ngAfterViewInit() {
    this.initTableau();
  }

  initTableau() {
    // const containerDiv = document.getElementById('vizContainer');
    const vizUrl =
      'https://usinsightreporting.cbre.com/t/LaborAnalyticsSandbox/views/Interviews/Interviewsoverview?:showAppBanner=false&:display_count=n&:showVizHome=n&:origin=viz_share_link' +
      '&output=embed';
    const options = {
      hideTabs: true,
      onFirstInteractive: () => {
        console.log('First chart display');
      },
      onFirstVizSizeKnown: () => {
        console.log('First chart size');
      },
    };
    this.viz = new tableau.Viz(this.containerDiv.nativeElement, vizUrl, options);
  }
}
